import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { DEFAULT_THEME_COLOR } from 'appenv';
import ButtonBase from '@material-ui/core/ButtonBase';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const ActionButton = ({ children, ...props }) => {
  const { themeColor } = useSelector((s) => s.eventConfigs);
  const CustomButton = withStyles(() => ({
    root: {
      color: '#FFF',
      backgroundColor: themeColor || DEFAULT_THEME_COLOR,
      height: '40px',
      borderRadius: '2px',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '16px',
      textTransform: 'uppercase',
      fontFamily: 'Lato',
      opacity: 'initial',
      width: '100%',
      flex: '0 0 auto',
    },
    disabled: {
      backgroundColor: themeColor || DEFAULT_THEME_COLOR,
      opacity: '0.4',
    },
  }))(ButtonBase);
  return <CustomButton {...props}>{children}</CustomButton>;
};

ActionButton.propTypes = {
  children: PropTypes.node.isRequired,
};
export default ActionButton;
